import React, { useState, useEffect, useRef } from "react";
import { useNavigate, Link } from "react-router-dom";
import DateIcon from "../../../imgs/date-icon.svg";
import ReqIcon from "../../../imgs/req-icon.svg";
import {
  createLot,
  trackLotEvent,
  fetchLotEvents,
} from "../../../network/fetch";
import ProgressBar from "../../../components/ProgressBar/ProgressBar";
import State from "../State";
import TutorialPopup from "../../../components/TutorialPopup/TutorialPopup";

const Step3Form = () => {
  const navigate = useNavigate();

  const [lotsStock, setLotsStock] = useState([...State.lots]);
  const [finalLot, setFinalLot] = useState(null);
  const [subLots, setSubLots] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const total_steps = 4;
  const current_step = 3;
  const [tutorialStep, setTutorialStep] = useState(0);
  const [txUrl, setTxUrl] = useState("");
  const dateInputRef = useRef(null);

  const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  useEffect(() => {
    // setLotsStock();
    State.lots = [];
  }, []);

  const supplyChainNextStep = (e) => {
    e.preventDefault();
    State.defaultClient = null;
    navigate("/supplychain/step4", {
      replace: true,
    });
    return;
  };

  const [tutorialSteps, setTutorialSteps] = useState([
    {
      content: (
        <>
          <p className="tutorial-title">Encodez vos données (1/2)</p>
          <p>
            En tant qu’opérateur de l’abattoir, vous devez enregistrer un lot de
            volailles prêtes à la consommation, composé des lots achetés à
            l’éleveur.
          </p>
        </>
      ),
      position: { top: "320px", left: "50%", transform: "translateX(-50%)" },
    },
    {
      content: (
        <>
          <p className="tutorial-title">Composition de lots (2/2)</p>{" "}
          <p>
            Créez un lot de volailles prêtes à la consommation en combinant des
            lots achetés à l'éleveur. Sélectionnez un ou plusieurs lots pour
            composer votre nouveau lot.
          </p>
        </>
      ),
      showArrow: true,
      position: { top: "470px", left: "55%", transform: "translateX(-50%)" },
      closeLabel: "hidden",
    },
    // Ajoutez plus d'étapes si nécessaire
  ]);

  let submitedStep = [
    {
      content: (
        <>
          <p className="tutorial-title">
            Informations enregistrées avec succès
          </p>
          <p>
            Vous avez enregistré les informations du lot de volailles prêtes à
            la consommation. Ces données sont maintenant disponibles sur la
            blockchain et accessibles aux autres acteurs de la chaîne. Cliquez
            sur le bouton ci-dessous pour consulter les informations partagées
            avec les autres parties prenantes.
          </p>
        </>
      ),
      closeLabel: "hidden",
      nextLabel: "Etape suivante",
      handleNextTutorialStep: (e)=>{
        supplyChainNextStep(e);
      },
      position: {
        top: "1080px",
        left: "50%",
        transform: "translateX(-50%)",
        width: "950px",
      },
    },
  ];

  const handleNextTutorialStep = (e) => {
    e.preventDefault();
    if (tutorialStep < tutorialSteps.length - 1) {
      setTutorialStep(tutorialStep + 1);
    } else {
      setTutorialStep(-1); // Toutes les étapes sont terminées

      if (finalLot) {
        navigate("/supplychain/step4", {
          replace: true,
        });
      }
    }
  };

  const handleCloseTutorial = (e) => {
    e.preventDefault();
    setTutorialStep(-1);
    if (finalLot) {
      navigate("/supplychain/step4", {
        replace: true,
      });
    }
  };

  // State for form fields
  const [formData, setFormData] = useState({
    location: "",
    lotId: "",
    quantity: "",
    weight: "",
    buyerInfo: State.defaultClient == null ? "" : State.defaultClient,
    transporter: "",
    departureDateTime: "",
    comment: "",
    date: new Date().toISOString().split("T")[0],
    toggle1: false,
    toggle2: false,
    toggle3: false,
    toggle4: false,
    toggle5: false,
  });

  let newLot = {
    lotId: "",
    quantity: 0,
    timestamp: "",
    location: "",
    buyer: State.defaultClient == null ? "" : State.defaultClient,
    subLotIds: "",
  };

  // Handle input change
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    newLot = {
      ...newLot,
      lotId: formData.lotId,
      quantity: formData.quantity,
      timestamp: formData.convertedDate,
      location: formData.location,
      buyer: State.defaultClient == null ? "" : State.defaultClient,
      subLotIds: subLots.join(","),
    };

    if (isFormValid()) {
      const resp = await createLot(newLot);

      await wait(1000);
      if (resp.success) {
        const eventData = {
          ...newLot,
          eventType: "composed_lot_type",
          eventData: {
            weight: formData.weight,
            transport: formData.transporter,
            start_date: formData.departureDateTime,
            comment: formData.comment,
          },
        };

        console.log("=== eventData === Step3Form.js === key: 196003 ===");
        console.dir(eventData, { depth: null, colors: true });
        console.log("=================================");

        const resp2 = await trackLotEvent(eventData);

        console.log("=== resp2 === Step3Form.js === key: 904805 ===");
        console.dir(resp2, { depth: null, colors: true });
        console.log("=================================");

        if (resp2.success === true) {
          State.lots = [eventData];
          console.log("=== eventData === Step3Form.js === key: 470646 ===");
          console.dir(eventData, { depth: null, colors: true });
          console.log("=================================");
          setTxUrl(resp2.data.tx_uri);
          State.txUri = resp2.data.tx_uri;
          setFinalLot(eventData);
          setTutorialSteps(submitedStep);
          setTutorialStep(0);
          /** ---------------------- cmt ----------------------
          * navigate("/supplychain/step4", {
            replace: true,
          });
          *--------------------------------------------------*/
        }
      }
    } else {
      alert("Veuillez remplir tous les champs obligatoires.");
    }

    setIsSubmitting(false);
  };

  const isFormValid = () => {
    formData.convertedDate = new Date(formData.date).toISOString();
    if (isNaN(formData.quantity)) {
      formData.quantity = 1;
    }
    formData.quantity = parseInt(formData.quantity || 0);

    formData.location = formData.location
      .replace(/\s+/g, " ")
      .replace(/,+/g, ",")
      .replace(/\.+/g, ".")
      .replace(/-+/g, "-")
      .replace(/[^\p{L}\p{N}\-., ]+/gu, "");

    formData.lotId = formData.lotId
      .replace(/\s+/g, "-")
      .replace(/-+/g, "-")
      .replace(/[^\p{L}\p{N}\-., ]+/gu, "");

    formData.buyerInfo =
      State.defaultClient == null
        ? formData.buyerInfo
            .replace(/\s+/g, " ")
            .replace(/[^\p{L}\p{N}\-., ]+/gu, "")
        : State.defaultClient;

    formData.transporter = formData.transporter
      .replace(/\s+/g, " ")
      .replace(/-+/g, "-")
      .replace(/[^\p{L}\p{N}\-., ]+/gu, "");

    formData.departureDateTime = formData.departureDateTime
      .replace(/\s+/g, " ")
      .replace(/-+/g, "-")
      .replace(/[^\p{L}\p{N}\-., ]+/gu, "");

    formData.comment = formData.comment
      .replace(/\s+/g, " ")
      .replace(/-+/g, "-")
      .replace(/[^\p{L}\p{N}\-., ]+/gu, "");

    return (
      formData.location &&
      formData.lotId &&
      formData.quantity &&
      formData.weight &&
      formData.buyerInfo &&
      formData.date &&
      formData.transporter &&
      formData.departureDateTime &&
      formData.comment
    );
  };

  const CheckboxList = ({ items }) => {
    return (
      <div>
        {items.map((item, index) => (
          <div className="form-check custom-checkbox" key={"lot_" + index}>
            <input
              className="form-check-input"
              type="checkbox"
              id={`lot${index + 1}`}
              name={`lot${index + 1}`}
              checked={formData[`lot${index + 1}`]}
              onChange={(e) => {
                let sl = [...subLots];
                if (e.target.checked) {
                  sl.push(item);
                } else {
                  sl.splice(sl.indexOf(item), 1);
                }
                sl = [...new Set(sl)];
                setSubLots(sl);
                handleChange(e);
              }}
            />
            <label className="form-check-label" htmlFor={`lot${index + 1}`}>
              {item}
            </label>
          </div>
        ))}
      </div>
    );
  };

  const SwitchesList = ({ items }) => {
    return (
      <div>
        {items.map((item, index) => (
          <div className="form-check form-switch" key={"toggle_" + index}>
            <input
              className="form-check-input"
              type="checkbox"
              id={`toggles${index + 1}`}
              name={`toggles${index + 1}`}
              checked={formData[`toggles${index + 1}`]}
              onChange={handleChange}
            />
          </div>
        ))}
      </div>
    );
  };

  return (
    <form onSubmit={handleSubmit} className="container form-2">
      <div className="form-heading-wrapper">
        <ProgressBar total_steps={total_steps} current_step={current_step} />
      </div>
      {tutorialStep >= 0 && (
        <TutorialPopup
          content={tutorialSteps[tutorialStep].content}
          position={tutorialSteps[tutorialStep].position}
          isVisible={tutorialStep >= 0}
          onNext={handleNextTutorialStep}
          onClose={handleCloseTutorial}
          txUrl={txUrl}
          showArrow={tutorialSteps[tutorialStep].showArrow === true}
          tmpNextLabel={tutorialSteps[tutorialStep].nextLabel}
          tmpCloseLabel={tutorialSteps[tutorialStep].closeLabel}
        />
      )}
      <div className="fiels-main-wrapper">
        <div className="fields-main">
          <div className="fields-main-switch-main">
            <div className="spacer"></div>
            <p className="form-switchs-label">Données confidentielles</p>
          </div>

          <div className="fields-main-item">
            <div className="form-field ">
              <label htmlFor="date" className="form-label">
                Date d'abattage
              </label>
              <input
                type="date"
                className="form-control"
                id="date"
                name="date"
                value={formData.date}
                onChange={handleChange}
                required
                placeholder="jj/mm/aaaa"
                onClick={(e) => e.target.showPicker && e.target.showPicker()}
                ref={dateInputRef}
              />
              <span
                className="date-icon"
                onClick={() =>
                  dateInputRef.current &&
                  dateInputRef.current.showPicker &&
                  dateInputRef.current.showPicker()
                }
              >
                <img src={DateIcon} alt="Date Icon"></img>
              </span>
            </div>
            <div className=" form-check form-switch">
              <input
                className="form-check-input"
                type="checkbox"
                id="toggle1"
                name="toggle1"
                checked={formData.toggle1}
                onChange={handleChange}
              />
            </div>
          </div>

          <div className="fields-main-item">
            <div className="form-field ">
              <label htmlFor="location" className="form-label">
                Localisation de l'abattoir
              </label>
              <input
                type="text"
                className="form-control"
                id="location"
                name="location"
                value={formData.location}
                onChange={handleChange}
                required
                placeholder="Bioul, Belgique"
                maxLength={45}
              />
            </div>

            <div className=" form-check form-switch">
              <input
                className="form-check-input"
                type="checkbox"
                id="toggle2"
                name="toggle2"
                checked={formData.toggle2}
                onChange={handleChange}
              />
            </div>
          </div>

          <div className="fields-main-item">
            <div className="form-field ">
              <label htmlFor="lotId" className="form-label">
                Nom du lot de volailles abattues
              </label>
              <input
                type="text"
                className="form-control"
                id="lotId"
                name="lotId"
                value={formData.lotId}
                onChange={handleChange}
                required
                placeholder="Lot GHI789"
                maxLength={25}
              />

              <div className="lot-details">
                <div className="composition">
                  <p>Composition du lot</p>
                  <CheckboxList items={lotsStock} />
                </div>
              </div>
            </div>

            <div className=" form-check form-switch">
              <input
                className="form-check-input"
                type="checkbox"
                id="toggle3"
                name="toggle3"
                checked={formData.toggle3}
                onChange={handleChange}
              />
            </div>
          </div>

          <div className="fields-main-item">
            <div className="form-field ">
              <label htmlFor="quantity" className="form-label">
                Quantité de volailles abattues
              </label>
              <input
                type="text"
                className="form-control"
                id="quantity"
                name="quantity"
                value={formData.quantity}
                onChange={handleChange}
                required
                placeholder="250"
                maxLength={9}
              />
            </div>
          </div>

          <div className="fields-main-item">
            <div className="form-field ">
              <label htmlFor="weight" className="form-label">
                Poids des volailles abattues
              </label>
              <input
                type="text"
                className="form-control"
                id="weight"
                name="weight"
                value={formData.weight}
                onChange={handleChange}
                required
                placeholder="500 kg"
                maxLength={15}
              />
            </div>

            <div className=" form-check form-switch">
              <input
                className="form-check-input"
                type="checkbox"
                id="toggle4"
                name="toggle4"
                checked={formData.toggle4}
                onChange={handleChange}
              />
            </div>
          </div>

          <div className="fields-main-item">
            <div className="form-field ">
              <label htmlFor="buyerInfo" className="form-label">
                Information acheteur
              </label>
              <input
                type="text"
                className="form-control"
                id="buyerInfo"
                name="buyerInfo"
                value={formData.buyerInfo}
                onChange={handleChange}
                required
                placeholder="Client DEF"
                maxLength={45}
              />
            </div>

            <div className=" form-check form-switch">
              <input
                className="form-check-input"
                type="checkbox"
                id="toggle5"
                name="toggle5"
                checked={formData.toggle5}
                onChange={handleChange}
              />
            </div>
          </div>

          <div className="fields-main-item">
            <div className="form-field ">
              <label htmlFor="transporter" className="form-label">
                Transporteur
              </label>
              <input
                type="text"
                className="form-control"
                id="transporter"
                name="transporter"
                value={formData.transporter}
                onChange={handleChange}
                required
                placeholder="Transporteur XYZ"
                maxLength={45}
              />
            </div>
          </div>
          <div className="fields-main-item">
            <div className="form-field ">
              <label htmlFor="departureDateTime" className="form-label">
                Date et heure de départ
              </label>
              <input
                type="text"
                className="form-control"
                id="departureDateTime"
                name="departureDateTime"
                value={formData.departureDateTime}
                onChange={handleChange}
                required
                placeholder="jj/mm/aaaa hh:mm"
                maxLength={25}
              />
            </div>
          </div>
          <div className="fields-main-item">
            <div className="form-field ">
              <label htmlFor="comment" className="form-label">
                Commentaire
              </label>
              <input
                type="text"
                className="form-control"
                id="comment"
                name="comment"
                value={formData.comment}
                onChange={handleChange}
                required
                placeholder="Commentaire sur la livraison"
                maxLength={45}
              />
            </div>
          </div>
        </div>

        <div className="btn-wrapper">
          {!isSubmitting ? (
            <button
              type="submit"
              className="btn btn-primary"
              disabled={!isFormValid() || subLots.length === 0 || finalLot}
            >
              Enregistrer le lot
            </button>
          ) : (
            <div className="spinner-wrapper">
              <div className="spinner-border" role="status">
                <span className="visually-hidden">Chargement...</span>
              </div>
            </div>
          )}
        </div>
      </div>
    </form>
  );
};

export default Step3Form;
